import { Tab, Tabs } from '@kpa/kul/lib/components/Tab';
import { ContentResponse } from '../types/shared';
import { FC, ReactNode } from 'react';
import { FlikgruppBlockResponse } from '../types/blocks';
import ContentArea from '../ContentArea';

type FlikgruppBlockProps = {
  contentResponse: ContentResponse;
};

const FlikgruppBlock: FC<FlikgruppBlockProps> = ({ contentResponse }): ReactNode => {
  const responseContent = contentResponse.content as FlikgruppBlockResponse;
  return (
    <Tabs className="flikgruppBlock">
      {responseContent.flikarna.map((flik, index) => (
        <Tab id={`${index}`} key={index} label={flik.etikett}>
          {flik.flikinnehåll && <ContentArea contentAreaResponse={flik.flikinnehåll} />}
        </Tab>
      ))}
    </Tabs>
  );
};

export default FlikgruppBlock;
